(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ExpenseType', ExpenseType);

    ExpenseType.$inject = ['$resource'];

    function ExpenseType ($resource) {
        var resourceUrl =  'api/expense-type/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
